import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UpdateVoucherRequestDTO, RequestVoucherResponse } from "@/types";
import { httpRequest } from "@/lib";

async function updateVoucher({
  id,
  ...request
}: UpdateVoucherRequestDTO): Promise<RequestVoucherResponse> {
  const response = await httpRequest.put<RequestVoucherResponse>(
    `/vouchers/${id}`,
    request
  );
  return response.data;
}

export function useUpdateVoucherMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateVoucher,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vouchers"] });
    },
  });
}
